// Per-browser stable client id + name persistence
const CLIENT_KEY = "samebrain.clientId";
const NAME_KEY = "samebrain.name";

export function getClientId(): string {
  let id = localStorage.getItem(CLIENT_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(CLIENT_KEY, id);
  }
  return id;
}

export function getStoredName(): string {
  return localStorage.getItem(NAME_KEY) ?? "";
}

export function setStoredName(name: string) {
  localStorage.setItem(NAME_KEY, name);
}

export function genRoomCode(): string {
  // 4 chars, no ambiguous (0/O, 1/I)
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let s = "";
  for (let i = 0; i < 4; i++) s += chars[Math.floor(Math.random() * chars.length)];
  return s;
}
